import { render, staticRenderFns } from "./SearchProfileWrapper.vue?vue&type=template&id=df5bb530"
import script from "./SearchProfileWrapper.vue?vue&type=script&lang=js"
export * from "./SearchProfileWrapper.vue?vue&type=script&lang=js"
import style0 from "./SearchProfileWrapper.vue?vue&type=style&index=0&id=df5bb530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports